import React from 'react';
import KGWizard from './wizard/KGWizard';

interface CreateVersionModalProps {
  kgId: string;
  onClose: () => void;
  onCreated: () => void;
  hasGdsLicense: boolean;
}

const CreateVersionModal: React.FC<CreateVersionModalProps> = ({ kgId, onClose, onCreated, hasGdsLicense }) => (
  <KGWizard mode="version" kgId={kgId} onClose={onClose} onCreated={onCreated} hasGdsLicense={hasGdsLicense} />
);

export default CreateVersionModal;